import React, { useState, useContext } from 'react';
import APILookupForm, { APILookupFormFormData, RequestTypeType } from 'src/components/APILookupForm';
import LocationInfoForm from 'src/components/LocationInfoForm';
import SummaryTypeTable from 'src/components/tables/DisplayNameTable';
import DataLinkInfoForm from 'src/components/DataLinkInfoForm';
import TransactionTypeTable from 'src/components/tables/TransactionTypeTable';
import GroupTypeTable from 'src/components/tables/GroupTypeTable';
import { Row, Col, RadioChangeEvent, Form } from 'antd';
import { AuthenticationContext } from 'src/providers/AuthenticationContext';
import LocationInfoDTO from '../models/generated/LocationInfoDTO';
import DataLinkInfoDTO from '../models/generated/DataLinkInfoDTO';
import ApiController from '../api/ApiController';
import SummaryTypeDTO from '../models/generated/SummaryTypeDTO';
import GroupTypeDTO from '../models/generated/GroupTypeDTO';
import TransactionTypeDTO from '../models/generated/TransactionTypeDTO';
export interface LocationDataProps {
    loadingData: boolean;
    setLoadingData: React.Dispatch<React.SetStateAction<boolean>>;
}
const LocationData: React.FC<LocationDataProps> = ({ loadingData, setLoadingData }) => {
    const [selectedButton, setSelectedButton] = useState<RequestTypeType>('Summary');
    const [filterTypeStrings, setfilterTypeStrings] = useState<Map<string, string[]>>(new Map([
        ['Summary', []],
        ['Groups', []],
        ['Transactions', []],
    ]));
    //const [dataLinkInfo, setdataLinkInfo] = useState<DataLinkInfoDTO>(DataLinkInfoDTO.create());
    const [summaryData, setSummaryData] = useState<SummaryTypeDTO[]>([]);
    const [transactionData, setTransactionData] = useState<TransactionTypeDTO[]>([]);
    const [groupData, setGroupData] = useState<GroupTypeDTO[]>([]);
    const authContext = useContext(AuthenticationContext);    
    const [locationInfoForm] = Form.useForm();
    const [dataLinkInfoForm] = Form.useForm();
    const viewChanged = (e: RadioChangeEvent) => {
        setSelectedButton(e.target.value);        
    };
    const submitForm = async (values: APILookupFormFormData) => {
        setLoadingData(true);
        const result = await ApiController.getTableDataForView(values);
        const filterSet = new Set<string>();
        const map = new Map(filterTypeStrings);
        if (result.data.summaryView.length > 0) {
            result.data.summaryView.forEach((f) => filterSet.add(f.name));
        }
        else if (result.data.transactionView.length > 0) {
            result.data.transactionView.forEach((f) => filterSet.add(f.transactionType));
        }
        else if (result.data.groupView.length > 0) {
            result.data.groupView.forEach((f) => filterSet.add(f.groupType));
        }
        map.set(values.requestType, Array.from(filterSet));
        setfilterTypeStrings(map);

        const dataLinkInfo = DataLinkInfoDTO.create(result.data);
        const locationInfo = LocationInfoDTO.create(result.data);
        const dataLinkFormVals = Object.keys(dataLinkInfo).map((key) => ({
            name: key,
            value: dataLinkInfo[key as keyof DataLinkInfoDTO]
        }));
        const locationFormVals = Object.keys(locationInfo).map((key) => ({
            name: key,
            value: locationInfo[key as keyof LocationInfoDTO]
        }));
        locationInfoForm.setFields(locationFormVals);
        dataLinkInfoForm.setFields(dataLinkFormVals);
        //update all data
        setSummaryData(result.data.summaryView);
        setTransactionData(result.data.transactionView);        
        setGroupData(result.data.groupView);
        setLoadingData(false);
    };
    interface gridProps {
        requestType: RequestTypeType;
    }
    const RenderGrids: React.FC<gridProps> = ({ requestType }) => {
        switch (requestType) {
            case 'Transactions':
                return <TransactionTypeTable data={transactionData} loading={loadingData} filterStrings={filterTypeStrings.get('Transactions') || []}></TransactionTypeTable>;
            //case 'Names':
            //    return <NameTypeTable data={[]} ></NameTypeTable>;
            case 'Groups':
                return <GroupTypeTable data={groupData} filterStrings={filterTypeStrings.get('Groups') || []} loading={loadingData} ></GroupTypeTable>;
            default:
                return <SummaryTypeTable data={summaryData} filterStrings={filterTypeStrings.get('Summary') || []} loading={loadingData}></SummaryTypeTable>;
        }        
    };
    return (
		<>
			<Row gutter={16}>
				<Col span={5}>
                    <APILookupForm setIsLoading={setLoadingData} isLoading={loadingData} maxDayRange={31} onSubmit={ submitForm } viewChanged={viewChanged}></APILookupForm>
                </Col>
                <Col span={1}>
                </Col>
				<Col span={12}>
                    <LocationInfoForm form={locationInfoForm}></LocationInfoForm>
				</Col>
				<Col span={6}>
                    <DataLinkInfoForm form={dataLinkInfoForm}></DataLinkInfoForm>
				</Col>
			</Row>
			<Row>
				<Col span={24}>
                    <RenderGrids requestType={selectedButton}></RenderGrids>
				</Col>
			</Row>
		</>
    );
};
export default LocationData;